import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private service: MatSnackBar) { }

  open(message: string, closeLabel: string = 'X') {
    return this.service.open(message, closeLabel,  {
      duration: 3000,
      panelClass: 'cim-toastr',
      verticalPosition: 'top'
    });
  }

  // Persistent variant: stays open until the user dismisses it. Used for
  // failure messages that the user must act on (e.g. "constraints are
  // inconsistent" -- a 3-second auto-dismiss can disappear before the
  // notification is even noticed).
  openPersistent(message: string, closeLabel: string = 'Dismiss') {
    return this.service.open(message, closeLabel, {
      duration: 0,
      panelClass: 'cim-toastr',
      verticalPosition: 'top'
    });
  }
  openWithAction(message: string, closeLabel: string = 'X', link: string = '') {
    const snackBarRef = this.service.open(message, closeLabel,  {
      duration: 10000,
      panelClass: 'cim-toastr',
      verticalPosition: 'top',
    });

    if (link) {
      snackBarRef.onAction().subscribe(() => {
        const baseUrl = `${window.location.protocol}//${window.location.host}/#/`;
        const fullUrl = `${baseUrl}${link.startsWith('/') ? link : `/${link}`}`;

        window.open(fullUrl, '_blank');
      });
    }

    return snackBarRef;
  }

  // Action variant that runs a callback instead of opening a link. Used for
  // the "optimization finished — reload" prompt, where the action reloads the
  // current page rather than navigating away. Persistent by default so the
  // user can reload whenever they choose.
  openWithCallback(message: string, actionLabel: string, onAction: () => void, duration: number = 0) {
    const snackBarRef = this.service.open(message, actionLabel, {
      duration,
      panelClass: 'cim-toastr',
      verticalPosition: 'top',
    });

    snackBarRef.onAction().subscribe(() => onAction());

    return snackBarRef;
  }

  invalidForm() {
    return this.open('Please fill the required fields!');
  }
}
